<template>
  <div v-if='entry'>
    <wc-page-title :title='entry.employee_obj.name_display' :subtitle='entry.date | longDate'>
      <template v-slot:rightSide>
        <span :class='titleClass'>{{entry.hours_worked.toFixed(2)}}</span>
      </template>
    </wc-page-title>
    <v-container class='pt-0'>
      <v-alert
        v-if='getError.error'
        border='top'
        colored-border
        :icon='getError.icon'
        :color='getError.color'
        :class='getError.color'
        class='lighten-4 pb-2'
      >
        <span class='body-2 font-weight-bold pt-0'>{{getError.text}}</span>
      </v-alert>

      <v-row>
        <v-col cols='12' md='4'>
          <timesheet-overview-basics
            v-if='entry'
            :entry='entry'
            @edit='openEdit'
          ></timesheet-overview-basics>
        </v-col>
        <v-col cols='12' md='8'>
          <timesheet-overview-details
            v-if='entry'
            :entry='entry'
            :workedOns='workedOns'
            @add='newWorkedOn'
            @delete='deleteWorkedOn'
          ></timesheet-overview-details>
        </v-col>
        <v-col cols='12' v-if='$vuetify.breakpoint.smAndDown'>
          <v-btn block elevation='0' color='warning' @click='returnToDashboard'>Return to Dashboard</v-btn>
        </v-col>
      </v-row>
    </v-container>

    <entry-basics-dialog
      :showDialog='showDialog'
      :entry='entry'
      @cancel='showDialog = false'
      @saved='updateEntryDisplay'
      @returnToDashboard='returnToDashboard'
    ></entry-basics-dialog>

    <entry-details-dialog
      :showDialog='showDetailDialog'
      :entry='entry'
      :workedOn='workedOnCopy'
      @cancel='cancelWorkedOn'
      @save='saveWorkedOn'
    ></entry-details-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
// import moment from 'moment'
import miscServices from '@/services/misc'
import timesheetsAPI from '../../api/timesheets'
import Basics from '../../components/Basics'
import Details from '../../components/Details'
import EntryBasicsDialog from '../../components/EntryBasicsDialog'
import EntryDetailsDialog from '../../components/EntryDetailsDialog'

export default {
  name: 'entry-overview',
  data: () => ({
    isFormValid: false,
    showDialog: false,
    showDetailDialog: false,
    workedOnCopy: {},
    blankWorkedOn: {},
    workedOns: [],
    entry: null,
  }),
  mounted () {
    this.isLoading = true
    this.getData()
    this.isLoading = false
  },
  computed: {
    divisions () {
      return _.orderBy(this.$store.state.misc.divisions, 'order')
    },
    titleClass () {
      if (this.$vuetify.breakpoint.xs) {
        return 'headline info--text font-weight-light text-uppercase'
      }
      return 'display-1 info--text font-weight-light text-uppercase'
    },
    getError() {
      if (this.entry.start === this.entry.end) {
        return { error: true, icon: 'mdi-briefcase-off', text: 'Did not work today', color: 'grey' }
      } else if (this.entry.start > this.entry.end) {
        return { error: true, icon: 'mdi-alert', text: 'Error - Time Paradox', color: 'error' }
      } else if (this.entry.hours_left_to_assign < 0) {
        return { error: true, icon: 'mdi-alert', text: 'You have too many hours assigned to details', color: 'error' }
      } else {
        return { error: false, icon: 'mdi-check', text: 'No Error (though if you see this alert... contact CPM2 Admin)', color: 'green' }
      }
    },
    detailsIcon () {
      if (!this.entry.hours_left_to_assign) {
        return 'mdi-format-list-bulleted'
      } else if (this.entry.hours_left_to_assign < 0) {
        return 'mdi-alert-octagon-outline'
      } else {
        return 'mdi-alert-outline'
      }
    },
  },
  methods: {
    async getData () {
      this.entry = await timesheetsAPI.getTimesheetEntry(this.$route.params.id)
      this.workedOns = await timesheetsAPI.getTimesheetWorkedOns(this.entry.id)
    },
    openEdit () {
      // this.entryCopy = _.cloneDeep(this.item)
      this.showDialog = true
    },
    updateEntryDisplay (entry) {
      this.entry = _.cloneDeep(entry)
      this.showDialog = false
    },
    newWorkedOn () {
      this.workedOnCopy = _.cloneDeep(this.blankWorkedOn)
      this.showDetailDialog = true
      // setTimeout(() => {
      //   this.$refs.form.reset()
      // }, 50)
      // setTimeout(() => {
      //   this.$refs.description.focus()
      // }, 100)
    },
    cancelWorkedOn () {
      this.showDetailDialog = false
    },
    async deleteWorkedOn (workedOn) {
      this.workedOns = miscServices.removeObject(this.workedOns, workedOn)
      await timesheetsAPI.deleteTimesheetWorkedOn(workedOn.id)
      this.calculateTimeLeftToAssign()
    },
    // editWorkedOn (workedOn) {
    //   this.workedOnCopy = _.cloneDeep(workedOn)
    // },
    async saveWorkedOn (workedOn) {
      let tmp = await timesheetsAPI.createTimesheetWorkedOn(workedOn)
      this.workedOns.push(tmp)
      this.calculateTimeLeftToAssign()
      this.showDetailDialog = false
    },
    returnToDashboard () {
      this.$router.push({ name: 'TimesheetsDashboard' })
    },
    async calculateTimeLeftToAssign() {
      let sum = _.sumBy(this.workedOns, 'num_hours')
      let hrs = this.entry.hours_worked - sum
      let entryCopy = _.cloneDeep(this.entry)
      entryCopy.hours_left_to_assign = hrs
      this.entry = await timesheetsAPI.updateTimesheetEntry(entryCopy)
    }
  },
  components: {
    'entry-basics-dialog': EntryBasicsDialog,
    'entry-details-dialog': EntryDetailsDialog,
    'timesheet-overview-basics': Basics,
    'timesheet-overview-details': Details,
  }
}
</script>
